import React from 'react';
import { SectionWrapper } from './SectionWrapper';
import { Star } from 'lucide-react';
export function TestimonialsRow() {
  const testimonials = [{
    name: 'Mariana L.',
    role: 'Mamá de 2 y 4 años · Plan de Calma',
    content: 'Pensé que era mi culpa que mis hijos gritaran tanto. El Tomo 2 me hizo entender qué pasaba en sus cerebros. Ayer tuvimos el primer berrinche en el súper y no grité. Funcionó.',
    rating: 5
  }, {
    name: 'Sofía R.',
    role: 'Mamá de 3 años · Plan de Calma',
    content: 'Lo mejor es que no es teoría aburrida. Son guiones exactos. Cuando empezó a tirar los juguetes, usé la frase del Tomo 3 y se calmó en minutos. Increíble.',
    rating: 5
  }, {
    name: 'Carolina M.',
    role: 'Mamá de 5 años · Plan de Calma',
    content: 'Las rutinas visuales del bono nos salvaron las mañanas. Ya no hay berrinches para vestirse ni para ir al jardín. Vale cada centavo.',
    rating: 5
  }];
  return <section className="py-20 md:py-28 bg-cream" data-id="element-353">
      <div className="container mx-auto px-4" data-id="element-354">
        <SectionWrapper data-id="element-355">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-playfair font-bold text-dark-green mb-14 text-center" data-id="element-356">
            Mamás que ya lo tienen. En sus palabras.
          </h2>
        </SectionWrapper>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto" data-id="element-357">
          {testimonials.map((testimonial, index) => <SectionWrapper key={index} delay={0.2 * (index + 1)} data-id="element-358">
              <div className="bg-white rounded-2xl p-8 shadow-md border border-sage/10 flex flex-col h-full hover:shadow-lg transition-shadow" data-id="element-359">
                <div className="flex justify-center mb-6 text-gold" data-id="element-360">
                  {[...Array(5)].map((_, i) => <Star key={i} size={20} fill="currentColor" stroke="none" data-id="element-361" />)}
                </div>

                <p className="font-poppins text-dark-green/80 italic mb-8 flex-grow text-center text-lg leading-relaxed" data-id="element-362">
                  "{testimonial.content}"
                </p>

                <div className="text-center pt-6 border-t border-sage/10" data-id="element-363">
                  <p className="font-poppins font-bold text-dark-green text-base" data-id="element-364">
                    {testimonial.name}
                  </p>
                  <p className="font-poppins text-dark-green/60 text-sm mt-1 font-medium" data-id="element-365">
                    {testimonial.role}
                  </p>
                </div>
              </div>
            </SectionWrapper>)}
        </div>
      </div>
    </section>;
}